import { faFileSlash } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import { themeClass } from '~/styles/theme.css'
import type { AttachmentType } from '../../types'
import {
  attachmentPage,
  attachmentPageIframe,
  attachmentsGeneratingSubtitle,
  attachmentsGeneratingTitle,
  noAttachments,
  noAttachmentsIcon
} from '../AttachmentsViewer.css'

export const HtmlViewer = ({ attachment }: { attachment: AttachmentType }) => {
  if (!attachment.content) {
    return (
      <div className={clsx(noAttachments, themeClass)}>
        <div className={noAttachmentsIcon}>
          <FontAwesomeIcon icon={faFileSlash} />
        </div>
        <div className={attachmentsGeneratingTitle}>
          Erreur lors du chargement du fichier HTML
        </div>
        <div className={attachmentsGeneratingSubtitle}>
          Le contenu du fichier n'est pas disponible.
        </div>
      </div>
    )
  }

  let decodedContent: string
  try {
    // Decode base64 content from utf-8
    decodedContent = decodeURIComponent(
      atob(attachment.content)
        .split('')
        .map((c) => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`)
        .join('')
    )
  } catch {
    // If base64 decode fails, assume content is already HTML
    decodedContent = attachment.content
  }

  // Decode HTML entities if present
  const tempDiv = document.createElement('div')
  tempDiv.innerHTML = decodedContent
  const unescapedContent = tempDiv.textContent || tempDiv.innerText || ''

  // Use unescaped content if it looks like HTML
  const htmlContent =
    unescapedContent.includes('<html') || unescapedContent.includes('<!DOCTYPE')
      ? unescapedContent
      : decodedContent

  return (
    <iframe
      className={clsx(attachmentPage, attachmentPageIframe, themeClass)}
      title={attachment.name}
      src={`data:text/html;charset=utf-8,${encodeURIComponent(htmlContent)}`}
    />
  )
}
